import { Button } from "@/components/ui";
import { useServiceWorkerUpdate } from "../../hooks/useServiceWorkerUpdate.js";

/**
 * UpdateBanner — Aviso de "hay una versión nueva".
 *
 * Aparece cuando el service worker terminó de instalar un build nuevo y quedó
 * en espera. La recarga es siempre decisión del usuario: en esta app puede
 * estar siguiendo un vehículo en vivo o con un reporte a medio filtrar.
 *
 * Se ancla abajo para no chocar con el banner de "sin conexión en tiempo real"
 * (que vive arriba) y por encima de la BottomNav en móvil.
 */
export default function UpdateBanner() {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      className="fixed left-4 right-4 z-[600] bottom-[calc(5rem+env(safe-area-inset-bottom))] md:left-auto md:right-4 md:bottom-4 md:max-w-sm flex items-center gap-3 px-4 py-3 rounded-xl border border-border bg-surface-1 sheen-2 shadow-panel"
    >
      <span
        className="material-symbols-outlined shrink-0 text-primary"
        style={{ fontSize: "20px" }}
      >
        rocket_launch
      </span>
      <p className="text-sm leading-snug text-text-primary flex-1">
        Hay una versión nueva disponible.
      </p>
      <Button size="sm" onClick={applyUpdate}>
        Actualizar
      </Button>
    </div>
  );
}
